import { TourAvailability, TourAvailabilityHotelYear, TourAvailabilityYears } from '@model/tours/tour-product';
import moment from 'moment';
import { map, flatten, minBy, compact } from 'lodash';
import { MONTH_FORMAT_SHORT } from '@model/common';

export const getMinPrice = (availabilityMonths: Array<TourAvailability>) =>
  minBy(availabilityMonths, ({ price }) => price.amount);

export const getCheapestForYear = (
  tourAvailabilityYear: Array<TourAvailabilityHotelYear>,
  cheapest?: TourAvailability
) => {
  let first: TourAvailability | undefined = undefined;
  for (let j = 0; j < tourAvailabilityYear.length; j++) {
    const year: TourAvailabilityHotelYear = tourAvailabilityYear[j];
    const months: Array<Array<TourAvailability>> = Object.values(year.months || {});
    for (let k = 0; k < months.length; k++) {
      const month: Array<TourAvailability> = months[k];
      for (let l = 0; l < month.length; l++) {
        const availability = month[l];
        if (
          !!availability.price &&
          !!availability.price.amount &&
          (!cheapest || availability.price.amount < cheapest.price.amount)
        ) {
          cheapest = availability;
        }
        if (!first || moment(availability.departureDate).isBefore(moment(cheapest?.departureDate))) {
          first = availability;
        }
      }
    }
  }
  return cheapest || first;
};

/*
 * Iterate through tour prices to retrieve the cheapest tour availability
 */
export function getCheapestTour(
  tourAvailabilityYears: TourAvailabilityYears,
  months?: string,
  year?: string
): TourAvailability {
  if (months) {
    const cheapestPerMonth = months.split(',').map((month) => {
      const [searchYear] = month.split('-');
      const availabilityYear = tourAvailabilityYears[searchYear];
      const monthLabel = moment(month).format(MONTH_FORMAT_SHORT);
      const availabilityMonths = flatten(compact(map(map(availabilityYear, 'months'), monthLabel)));
      const lowestPrice = availabilityMonths.length > 0 && getMinPrice(availabilityMonths);
      if (lowestPrice) {
        return lowestPrice;
      }
    });
    const cheapestOverall = getMinPrice(compact(cheapestPerMonth));
    if (cheapestOverall) {
      return cheapestOverall;
    }
  }

  const years = Object.values(tourAvailabilityYears);
  let cheapest;
  if (year) {
    cheapest = getCheapestForYear(tourAvailabilityYears[year]);
  } else {
    for (let i = 0; i < years.length; i++) {
      cheapest = getCheapestForYear(years[i], cheapest);
    }
  }
  return cheapest;
}
